import React from "react"
import MenuItem from "@material-ui/core/MenuItem"
import TextField from "./TextField"

export default function SelectField({ options, ...props }) {
  return (
    <TextField select {...props}>
      {options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  )
}
